import { mediaById } from './media'
import type { PulseRing } from '../types'

export const pulses: PulseRing[] = [
  {
    id: 'pulse-lucas',
    authorId: 'lucas',
    seen: false,
    items: [
      {
        id: 'pl1',
        media: mediaById('running').url,
        kind: 'running',
        label: { 'pt-BR': 'Treino de manhã', 'en-US': 'Morning run' },
        metric: { 'pt-BR': '12,4 km · 5:00/km', 'en-US': '12.4 km · 5:00/km' },
      },
      {
        id: 'pl2',
        media: mediaById('recovery').url,
        kind: 'lifestyle',
        label: { 'pt-BR': 'Recuperação', 'en-US': 'Recovery' },
        metric: { 'pt-BR': '15 min de rolo', 'en-US': '15 min rolling' },
      },
    ],
  },
  {
    id: 'pulse-marina',
    authorId: 'marina',
    seen: false,
    items: [
      {
        id: 'pm1',
        media: mediaById('mindfulness').url,
        kind: 'mindfulness',
        label: { 'pt-BR': 'Respiração', 'en-US': 'Breathing' },
        metric: { 'pt-BR': '5 min · manhã', 'en-US': '5 min · morning' },
      },
    ],
  },
  {
    id: 'pulse-camila',
    authorId: 'camila',
    seen: false,
    items: [
      {
        id: 'pc1',
        media: mediaById('nutrition').url,
        kind: 'nutrition',
        label: { 'pt-BR': 'Refeição', 'en-US': 'Meal' },
        metric: { 'pt-BR': 'Pós-treino', 'en-US': 'Post-workout' },
      },
    ],
  },
  {
    id: 'pulse-pedro',
    authorId: 'pedro',
    seen: true,
    items: [
      {
        id: 'pp1',
        media: mediaById('cycling').url,
        kind: 'cycling',
        label: { 'pt-BR': 'Pedal na serra', 'en-US': 'Mountain ride' },
        metric: { 'pt-BR': '48 km · 720 m', 'en-US': '48 km · 720 m' },
      },
    ],
  },
  {
    id: 'pulse-juliana',
    authorId: 'juliana',
    seen: true,
    items: [
      {
        id: 'pj1',
        media: mediaById('swimming').url,
        kind: 'swimming',
        label: { 'pt-BR': 'Série na piscina', 'en-US': 'Pool set' },
        metric: { 'pt-BR': '10×100 m', 'en-US': '10×100 m' },
      },
    ],
  },
]
